/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Bogdan Shtybin <bogdan.shtybin@opensoftdev.com>
 */
import { extend } from 'underscore';
import backbone from 'backbone';
import StartPage from 'assets/js/modules/pages/start/startPage';
import StartPageModel from 'assets/js/modules/pages/start/model/startPageModel';
import ProductGroupModel from 'assets/js/modules/product/model/productGroupModel';

export default class {
    constructor(selector, params) {
        const { showDvsDesigner, showUploadInfo, handleBannerClicks, StartPageView, galleryBlockSize } = params;
        const $productDetails = $(selector);
        const parseNumber = value => {
            const numberValue = parseInt(value, 10);
            return Number.isNaN(numberValue) ? null : numberValue;
        };

        const startPageModel = new StartPageModel({
            productGroup: new ProductGroupModel({
                slug: $productDetails.data('slug'),
                name: $productDetails.data('name'),
                gallery: $productDetails.data('gallery')
            }),
            currency: $productDetails.data('currency'),
            showDvsDesigner,
            showUploadInfo,
            handleBannerClicks,
            eventAgent: extend({}, backbone.Events),
            defaultProduct: $productDetails.data('default-product'),
            defaultSides: parseNumber($productDetails.data('default-sides')),
            defaultQuantity: parseNumber($productDetails.data('default-quantity')),
            defaultSkuId: parseNumber($productDetails.data('default-sku'))
        });
        new StartPage(startPageModel);
        new StartPageView({
            model: startPageModel,
            el: $('.body-content'),
            galleryBlockSize
        });
    }
}
